// Written by tools/process-anim.py — frame sizes of public/art/anim/<name>.webp (D137).
import type { AnimSheet } from './unitAnim';

export const UNIT_ANIM_FRAMES: Readonly<Record<string, AnimSheet>> = {
  'walker': { fw: 174, fh: 160, bodyH: 150, footY: 158 },
  'ranger': { fw: 187, fh: 165, bodyH: 150, footY: 163 },
  'bloater': { fw: 174, fh: 161, bodyH: 150, footY: 159 },
  'brute': { fw: 163, fh: 162, bodyH: 150, footY: 160 },
  'engineer': { fw: 186, fh: 176, bodyH: 150, footY: 174 },
  'heavy': { fw: 172, fh: 168, bodyH: 150, footY: 166 },
  'worker-wood': { fw: 167, fh: 157, bodyH: 150, footY: 155 },
  'runner': { fw: 258, fh: 170, bodyH: 150, footY: 168 },
  'sniper': { fw: 190, fh: 154, bodyH: 150, footY: 152 },
  'worker-food': { fw: 105, fh: 165, bodyH: 150, footY: 163 },
  'worker-scrap': { fw: 113, fh: 155, bodyH: 150, footY: 153 },
  'flamer': { fw: 196, fh: 163, bodyH: 150, footY: 161 },
  'screamer': { fw: 125, fh: 175, bodyH: 150, footY: 173 },
};
